define.alias("shared/components/shared/publish/index", "calendar/components/shared/publish/index");